import { Formik, Form, ErrorMessage} from "formik";
import React, {useState, useEffect} from "react";
import  {Box, Button, } from '@mui/material/';
import NumberInputItem from "../numberInputItem";
import '../../../css/App.css'
import * as Yup from 'yup'
import idaThresholds from "../../../utilities/idAnaemia/idaThresholds";
import idaDisplayText from "../../../utilities/idAnaemia/idaDisplayText";

function IronDeficiencyForm(props)
{
const [validation, setValidation] = useState(  {Haemoglobin:Yup.number().required("Please enter the Haemoglobin value"),})
const [initialValues, setInitialValues]= useState()
const[fieldsToUse,setFieldsToUse]= useState()
const [componentsToDisplay, setComponentsToDisplay]= useState()
let sex = props.sex
const validationSchema=Yup.object(validation)
let newfieldsToUse = fieldsToUse
let newValidation= validation

const runUpdate=()=>{
    if(initialValues!==undefined)
    {
    const fieldsToDisplay =Object.keys(fieldsToUse)
    let components =fieldsToDisplay.map((value,key)=><NumberInputItem name={value} display ={idaDisplayText[value]} key={key} fieldsToUse={fieldsToUse}/>)
    setComponentsToDisplay(components)
    setFieldsToUse(fieldsToUse)
    }
}

useEffect(()=>{
  if (initialValues ===undefined)

  {
setInitialValues(
    {
      Haemoglobin:"",
      Ferritin:"",
     // MCV:"", (uncomment if local guidance uses MCV)
      TIBC:"",
      ironSat: ""

    }
)
  }
  if (newfieldsToUse === undefined)
  {
setFieldsToUse({Haemoglobin:"",})
  }
},[props.open])

useEffect (()=>{runUpdate()},[fieldsToUse])

const onSubmit=(values)=>

    { 
    let hbThreshold=0
    let validatation ={}
    if (sex === "male")
    {
    hbThreshold = idaThresholds.hbMale
    }
  else 
    {
    hbThreshold= idaThresholds.hbFemail
    }

  if (values.Haemoglobin > hbThreshold)
    {
   props.setIdMessage("The patient is not anaemic")
    display(false,values)
    return
    }

  else 
  {
  if (!fieldsToUse.hasOwnProperty("Ferritin"))
    {
    newfieldsToUse["Ferritin"]=""
    newValidation["Ferritin"]=Yup.number().required("Please enter the Ferritin value")
    setFieldsToUse(newfieldsToUse)
    setValidation(newValidation)
    runUpdate(newfieldsToUse)
    return
    }
  }
  if (values.Ferritin > idaThresholds.ferritinExclude )
    {
     props.setIdMessage(`The patient does not have iron deficiency (Ferritin > ${idaThresholds.ferritinExclude})`)
      display(false,values)
      return 
    }
  else if (values.Ferritin < idaThresholds.ferritinConditional)
    {
   props.setIdMessage(`The patient has iron deficiency (Ferritin < ${idaThresholds.ferritinConditional})`)
    display(true,values)
    return 
    }

  else if (props.riseWithIron)
    {props.setIdMessage("The patient has iron deficiency (Hb rise with iron therapy)")
     display(true,values)
     return 
    }

  /* else 
  ------MCV not used in current LSC ICS guidance (uncomment if local guidance uses MCV and set MCV threshold in idaThresholds.js)-------
    {
    if (!fieldsToUse.hasOwnProperty("MCV"))
      {
      newfieldsToUse["MCV"]=""
      newValidation["MCV"]=Yup.number().required("Please enter the MCV value")
      setFieldsToUse(newfieldsToUse)
      setValidation(newValidation)
      runUpdate(newfieldsToUse)
      return
      }
    }

  if (values.MCV < idaThresholds.MCV)
    {props.setIdMessage(`The patient has iron deficiency (MCV < ${idaThresholds.MCV})`)
    display(true, values)
    return 
  } */

  else 
    {
    if (!fieldsToUse.hasOwnProperty("TIBC"))
      {
      newfieldsToUse["TIBC"]=""
      newfieldsToUse["ironSat"]=""
      newValidation["TIBC"]=Yup.number().required("Please enter the TIBC value")
      newValidation["ironSat"]=Yup.number().required("Please enter the Iron Saturation value")
      setFieldsToUse(newfieldsToUse)
      setValidation(newValidation)
      runUpdate(newfieldsToUse)
      return
      }
    }
    if (values.TIBC > idaThresholds.TIBC && values.ironSat < idaThresholds.ironSat)
    {props.setIdMessage("The patient has iron deficiency (Low iron saturation with high TIBC)")
    display(true, values)
    return 
    }

    else
    {props.setIdMessage("The patient does not meet the criteria for iron deficiency.")
    display(false, values)
    return 
    }
  }
  
const display=(isIdAnaemia,values)=>
  {
  props.setIdaFormValues(values)
  let displayDelay=()=>setTimeout(()=>{
  props.setAnaemia(isIdAnaemia)
  props.setIdMessage("")
  props.setIdaFormSubmitted(true)
  },1000)
  displayDelay() 

  clearTimeout(displayDelay())
  }

return(
<Box>
 <Formik
enableReinitialize
mapPropsToValues
initialValues={initialValues}
onSubmit={onSubmit}
validationSchema={validationSchema}>
<Form>
{componentsToDisplay}

<ErrorMessage name="Haemoglobin" >
  {errorMsg=><div className="error">{errorMsg}</div>}
  </ErrorMessage>
 <ErrorMessage name="MCV" >
  {errorMsg=><div className="error">{errorMsg}</div>}
  </ErrorMessage>
  <ErrorMessage name="Ferritin" >
  {errorMsg=><div className="error">{errorMsg}</div>}
  </ErrorMessage>
  <ErrorMessage name="TIBC" >
  {errorMsg=><div className="error">{errorMsg}</div>}
  </ErrorMessage>
  <ErrorMessage name="ironSat" >
  {errorMsg=><div className="error">{errorMsg}</div>}
  </ErrorMessage>

<Button variant="contained" type="submit" > Continue</Button>
</Form>    
</Formik>

</Box>
)
}
export default IronDeficiencyForm